export default "__VITE_ASSET__B9dKP6_h__"